import { useState, useEffect } from 'react'
import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Products } from './components/products'
import { About } from './components/about'
import { Services } from './components/services'
import { Network } from './components/network'
/*
import { Prism } from './components/prism'
import { Risklynx } from './components/risklynx'
import { Facet } from './components/facet'
import { Team } from './components/Team'
*/
import { Contact } from './components/contact'
import JsonData from './data/data.json'
import SmoothScroll from 'smooth-scroll'

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
})

const App = () => {
  const [landingPageData, setLandingPageData] = useState({})
  useEffect(() => {
    setLandingPageData(JsonData)
  }, [])

  return (
    <div>
      <Navigation />
      <Header data={landingPageData.Header} />
      <Products data={landingPageData.Products} />
      <About data={landingPageData.About} />
      <Services data={landingPageData.Services} />
      <Network data={landingPageData.Network} />
      {/*
      <Risklynx data={landingPageData.Risklynx} />
      <Prism data={landingPageData.Prism} />
      <Facet data={landingPageData.Facet} />
      <Team data={landingPageData.Team} />
      */}
      <Contact data={landingPageData.Contact} />
    </div>
  )
}

export default App
